// Generated by ScalaTS 0.8.2: https://scala-ts.github.io/scala-ts/

declare var exports: any;

export const nsExtern = exports;

export const ExternInhabitant = 'Extern';

export type Extern = typeof ExternInhabitant;

export function isExtern(v: any): v is Extern {
  return ExternInhabitant == v;
}

export type ExternSingleton = Extern;
